export default "__VITE_ASSET__UAmUXenr__"